import React, { Fragment, useEffect, useState, useContext } from "react";
import { Box ,Divider } from "@mui/material";
import './dashboard.css';
import { BankRatesAPI } from '../../service/bankrates.service';
import { Context as AuthContext } from '../../context/auth_context';
import "../dashboard/leftsection.css"

const LeftSection = () => {

    const { logoutCall, state} = useContext(AuthContext);
    const { user_detail } = state
    //console.log("user detail on Dashboard page", user_detail)
    const[bankRateShow,setBankRateShow]=useState([]);
    console.log("bankRateShow:", bankRateShow);



    useEffect(()=>{
        console.log("Calling Bank Rate API Call from Left Section", user_detail)
        BankRatesAPI({
            access_token: user_detail.access_token
        },(res) =>{
            console.log("printing responce of get bank rates api" ,res) 
        
            if(res.data.status === true){
            console.log("responce sucessfully")
            var data = res.data.data;
            console.log(data)
            data[0].latest_rate = data[0].latest_rate.replace(/▲|▼/gi,"").trim();
            setBankRateShow(data)
        }
    },(err) => {
        console.log("Got Error",err)
    }
    )},[])


    return (
        <Fragment>
           <div className='left_section'>
                    <div className="sidebar-box-area" >
                        {/* <button onClick = {logoutCall}> Logout </button> */}
                        <h4 className="page-heading">Bank Rates</h4>
                        <div className="tradingview-widget-container" style={{ width: "100%", height: "100%" }}>
                            {/* <iframe scrolling="no" allowtransparency="true" frameBorder="0" src="https://s.tradingview.com/embed-widget/market-overview/?locale=in#%7B%22colorTheme%22%3A%22light%22%2C%22dateRange%22%3A%2212m%22%2C%22showChart%22%3Afalse%2C%22largeChartUrl%22%3A%22%22%2C%22isTransparent%22%3Afalse%2C%22width%22%3A%22100%25%22%2C%22height%22%3A%22100%25%22%2C%22tabs%22%3A%5B%7B%22title%22%3A%22Indices%22%2C%22symbols%22%3A%5B%7B%22s%22%3A%22OANDA%3ASPX500USD%22%2C%22d%22%3A%22S%26P%20500%22%7D%2C%7B%22s%22%3A%22OANDA%3ANAS100USD%22%2C%22d%22%3A%22Nasdaq%20100%22%7D%2C%7B%22s%22%3A%22FOREXCOM%3ADJI%22%2C%22d%22%3A%22Dow%2030%22%7D%2C%7B%22s%22%3A%22INDEX%3ANKY%22%2C%22d%22%3A%22Nikkei%20225%22%7D%2C%7B%22s%22%3A%22INDEX%3ADEU30%22%2C%22d%22%3A%22DAX%20Index%22%7D%2C%7B%22s%22%3A%22OANDA%3AUK100GBP%22%2C%22d%22%3A%22FTSE%20100%22%7D%5D%2C%22originalTitle%22%3A%22Indices%22%7D%2C%7B%22title%22%3A%22Commodities%22%2C%22symbols%22%3A%5B%7B%22s%22%3A%22CME_MINI%3AES1!%22%2C%22d%22%3A%22E-Mini%20S%26P%22%7D%2C%7B%22s%22%3A%22CME%3A6E1!%22%2C%22d%22%3A%22Euro%22%7D%2C%7B%22s%22%3A%22COMEX%3AGC1!%22%2C%22d%22%3A%22Gold%22%7D%2C%7B%22s%22%3A%22NYMEX%3ACL1!%22%2C%22d%22%3A%22Crude%20Oil%22%7D%2C%7B%22s%22%3A%22NYMEX%3ANG1!%22%2C%22d%22%3A%22Natural%20Gas%22%7D%2C%7B%22s%22%3A%22CBOT%3AZC1!%22%2C%22d%22%3A%22Corn%22%7D%5D%2C%22originalTitle%22%3A%22Commodities%22%7D%2C%7B%22title%22%3A%22Bonds%22%2C%22symbols%22%3A%5B%7B%22s%22%3A%22CME%3AGE1!%22%2C%22d%22%3A%22Eurodollar%22%7D%2C%7B%22s%22%3A%22CBOT%3AZB1!%22%2C%22d%22%3A%22T-Bond%22%7D%2C%7B%22s%22%3A%22CBOT%3AUB1!%22%2C%22d%22%3A%22Ultra%20T-Bond%22%7D%2C%7B%22s%22%3A%22EUREX%3AFGBL1!%22%2C%22d%22%3A%22Euro%20Bund%22%7D%2C%7B%22s%22%3A%22EUREX%3AFBTP1!%22%2C%22d%22%3A%22Euro%20BTP%22%7D%2C%7B%22s%22%3A%22EUREX%3AFGBM1!%22%2C%22d%22%3A%22Euro%20BOBL%22%7D%5D%2C%22originalTitle%22%3A%22Bonds%22%7D%2C%7B%22title%22%3A%22Forex%22%2C%22symbols%22%3A%5B%7B%22s%22%3A%22FX%3AEURUSD%22%7D%2C%7B%22s%22%3A%22FX%3AGBPUSD%22%7D%2C%7B%22s%22%3A%22FX%3AUSDJPY%22%7D%2C%7B%22s%22%3A%22FX%3AUSDCHF%22%7D%2C%7B%22s%22%3A%22FX%3AAUDUSD%22%7D%2C%7B%22s%22%3A%22FX%3AUSDCAD%22%7D%5D%2C%22originalTitle%22%3A%22Forex%22%7D%5D%2C%22utm_source%22%3A%22mac.acrylicfinancial.com%22%2C%22utm_medium%22%3A%22widget_new%22%2C%22utm_campaign%22%3A%22market-overview%22%7D" style={{ boxSizing: "border-box", height: "calc(100% - 32px)", width: "100%", }}></iframe> */}
                          
                           <Box className="br_box">
                            {bankRateShow.map((val)=>{
                                return(
                                    <>
                                    <Box className="box">
                                            <div className='first_div'>
                                                <div className='first_box_br'>{val?.rate_indexes}</div>
                                                <div className='second_box_br'>{(val?.rate_indexes == "SOFR")?val?.latest_rate:val?.week_change}%</div>   
                                            </div>
                                            <div className='second_div'>
                                                <div className='first_box_br_down'></div>
                                                <div className='second_box_br_down'></div>   
                                            </div>
                                            <Divider/>
                                        </Box>
                                    </>
                                )
                            })}
                           
                           </Box>
                    </div>
                    </div>
                    </div>
                   
                
                
        </Fragment>
   
    )

};

export default LeftSection;